import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import { useState } from "react";
import { TLocation } from "../api.js";
import { useTranslation } from "react-i18next";

interface DropdownOption {
  label: string;
  id: string;
}

export const OrdersFilter = (props: {
  selectedLocation: string;
  searchKey: string;
  availableLocations: TLocation[];
  handleLocationChange: (locationId: string) => void;
  handleSearchKeyChange: (selectedKey: string) => void;
}) => {
  const { t } = useTranslation();
  const [searchLocationId, setSearchLocationId] = useState<string>(
    props.selectedLocation,
  );
  const [searchKey, setSearchKey] = useState<string>(
    props.searchKey,
  )

  const searchKeyOptions = [
    {label: "Order ID", id: "orderID"},
    {label: "Auth Identifier", id: "authIdentifier"}
  ]
  const [allLocations] = useState<DropdownOption[]>([
    ...props.availableLocations.map((location) => {
      return {
        label: location.name,
        id: location.locationID,
      };
    }),
  ]);

  const handleLocationDropdownChange = (event: any, newValue: DropdownOption) => {
    if (newValue) {
      setSearchLocationId(newValue.id);
      props.handleLocationChange(newValue.id);
    }
  };

  const handleKeyDropdownChange = (event: any, newValue: DropdownOption) => {
    setSearchKey(newValue.id);
    props.handleSearchKeyChange(newValue.id)
  }

  return (
    <Box sx={{ width: "100%", marginTop: "1rem" }}>
      <FormControl fullWidth size={"small"} color={"primary"} sx={{flexDirection: "row"}}>
        <Autocomplete
          id="locationSelector"
          options={allLocations}
          getOptionLabel={(location) => location.label}
          value={allLocations.find((loc) => loc.id === searchLocationId)}
          onChange={handleLocationDropdownChange}
          size={"small"}
          autoHighlight
          sx={{ borderRadius: "20px", width: 300 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("order_details.select_location")}
              required
              sx={{
                borderRadius: "30px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                  py: "0px",
                },
              }}
            />
          )}
          disableClearable
        />

        <Autocomplete
          id="searchKeySelector"
          options={searchKeyOptions}
          getOptionLabel={(keyOp) => keyOp.label}
          value={searchKeyOptions.find((keyOp) => keyOp.id === searchKey)}
          onChange={handleKeyDropdownChange}
          size={"small"}
          autoHighlight
          sx={{ borderRadius: "20px", width: 300, ml: "1rem" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("order_details.search_key")}
              required
              sx={{
                borderRadius: "30px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                  py: "0px",
                },
              }}
            />
          )}
          disableClearable
        />
      </FormControl>
    </Box>
  );
};
